export const engagementDragAndDropContentBlocks = "/engagement/draganddrop_content_blocks";
